import { jsx as _jsx } from "react/jsx-runtime";
import { selectedItemsCountSelector } from "@air/redux-selected-items";
import pluralize from "pluralize";
import { useSelector } from "react-redux";
export const ContentCollectionItemsSelected = ()=>{
    const selectedItemsCount = useSelector(selectedItemsCountSelector);
    if (!selectedItemsCount) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "px-2 text-14 text-grey-12",
        "data-testid": "CONTENT_COLLECTION_ITEMS_SELECTED",
        children: "".concat(selectedItemsCount, " ").concat(pluralize("item", selectedItemsCount), " selected")
    });
};
